import { useNode } from '@craftjs/core';
import { FormTimeInputComponent } from 'src/features/generalForms/builder/types/DateInput';
import { useFormContext } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { HookFormTimePickerField } from 'src/features/generalForms/uikit/hookFormFields/hookFormTimeInputField';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';

export const FormTimeInput: FormTimeInputComponent = (props) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);

  if (!visible) {
    return <></>;
  }

  return (
    <div style={{ ...styles, boxSizing: 'border-box' }}>
      <HookFormTimePickerField
        disabled={isDisabled}
        control={form.control}
        name={props.dataKey!}
        timeEntriesIntervalInMinutes={props.timeIntervalInMinutes}
        placeholder={props.placeholder}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        isRequired={!props.isOptional}
        rules={hookFormRules({
          required: !props.isOptional && !isDisabled,
        })}
        errorProps={{ errors }}
        defaultValue={props.defaultValue}
      />
    </div>
  );
};
